import { Plane, MapPin, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Hero() {
  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="pt-32 pb-16 lg:pt-40 lg:pb-24" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-left animate-slide-up">
            <span className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              Your Dream Vacation Awaits
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-sky-900 leading-tight mb-6">
              Travel Easily With{" "}
              <span className="text-sky-600">CloudJet</span>
            </h1>
            <p className="text-lg text-sky-700 mb-8 max-w-lg">
              Experience breathtaking destinations, seamless travel planning, and unforgettable memories. 
              Let us take you on the journey of a lifetime.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="bg-sky-600 hover:bg-sky-700 text-white px-8 py-6 text-lg"
                data-testid="hero-start-journey-btn">

                Start Your Journey
              </Button>
              <Button
                onClick={() => document.querySelector("#destinations").scrollIntoView({ behavior: "smooth" })}
                variant="outline"
                size="lg"
                className="border-sky-600 text-sky-600 hover:bg-sky-50 px-8 py-6 text-lg"
                data-testid="hero-explore-btn">

                Explore Destinations
              </Button>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center">
                  <Plane className="text-sky-600" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-sky-900">500+</p>
                  <p className="text-sm text-sky-600">Destinations</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center">
                  <MapPin className="text-sky-600" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-sky-900">50+</p>
                  <p className="text-sm text-sky-600">Countries</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center">
                  <Calendar className="text-sky-600" size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-sky-900">10k+</p>
                  <p className="text-sm text-sky-600">Happy Travelers</p>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative animate-fade-in">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/358358/pexels-photo-358358.jpeg"
                alt="Beautiful sunny beach destination"
                className="w-full h-[500px] object-cover"
                data-testid="hero-image" />

              {/* Solid color overlay for text readability */}
              <div className="absolute bottom-0 left-0 right-0 bg-sky-900/70 p-6">
                <div className="flex items-center justify-between text-white">
                  <div>
                    <p className="text-lg font-semibold">Featured Destination</p>
                    <p className="text-sky-200">Maldives Paradise</p>
                  </div>
                  <Button
                    variant="secondary"
                    className="bg-white text-sky-700 hover:bg-sky-50"
                    data-testid="hero-learn-more-btn">

                    Learn More
                  </Button>
                </div>
              </div>
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-4 border border-sky-100 hidden lg:block">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center">
                  <span className="text-xl">★</span>
                </div>
                <div>
                  <p className="font-semibold text-sky-900">4.9 Rating</p>
                  <p className="text-sm text-sky-600">2,500+ Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}